import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "h-editor",
  style: {"border":"1px solid #ccc"}
}

import { onBeforeUnmount, ref, shallowRef, watch } from 'vue'
  import '@wangeditor/editor/dist/css/style.css'; // 引入 css
  import { Boot } from '@wangeditor/editor'
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue';

  interface Props {
    modelValue: string;
    // 编辑器配置
    editorConfig?: object;
    // toolbar配置
    toolbarConfig?: object;
    mode?: string;
    height?: number;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {},
    editorConfig: { default: { placeholder: '请输入内容...' } },
    toolbarConfig: { default: {} },
    mode: { default: "default" },
    height: { default: 500 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

  const emits = __emit;

  const toolbarRef = ref();



  const props = __props;


  /**
   * 内容 HTML
   */
  const valueHtml = ref("");

  watch(() => props.modelValue, (value: string) => {
    valueHtml.value = value;

  });


  watch(valueHtml, (value: string) => {
    emits("update:modelValue", value);
  });


  /**
   * 编辑器实例，必须用 shallowRef
   */
  const editorRef = shallowRef();

  /**
   * @description 获取编辑器实例
   */
  const getEditorRef = () => {
    return editorRef.value;
  }
  // 组件销毁时，也及时销毁编辑器
  onBeforeUnmount(() => {
    const editor = editorRef.value
    if (editor == null) return
    editor.destroy()
  });

  const handleCreated = (editor) => {
    editorRef.value = editor // 记录 editor 实例，重要！
  }

  __expose({
    getEditorRef
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Toolbar), {
      style: {"border-bottom":"1px solid #ccc"},
      ref_key: "toolbarRef",
      ref: toolbarRef,
      editor: editorRef.value,
      defaultConfig: _ctx.toolbarConfig,
      mode: _ctx.mode
    }, null, 8, ["editor", "defaultConfig", "mode"]),
    _createVNode(_unref(Editor), {
      style: _normalizeStyle([{height: _ctx.height + 'px'}, {"overflow-y":"hidden"}]),
      modelValue: valueHtml.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valueHtml).value = $event)),
      defaultConfig: _ctx.editorConfig,
      mode: _ctx.mode,
      onOnCreated: handleCreated
    }, null, 8, ["style", "modelValue", "defaultConfig", "mode"])
  ]))
}
}

})